import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getPokeInfo = createAsyncThunk(
    "pokemon/getPokeInfo",
    async (post) => {  
        const pokeId = Math.floor(Math.random() * 500);
        const response = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokeId}`);
        const data = response.json();

        return data;
    }
);

export const showModal = createAction("pokemon/showModal");